import { render, staticRenderFns } from "./applyRefundDialog.vue?vue&type=template&id=dd4bc4d0&scoped=true&"
import script from "./applyRefundDialog.vue?vue&type=script&lang=js&"
export * from "./applyRefundDialog.vue?vue&type=script&lang=js&"
import style0 from "./applyRefundDialog.vue?vue&type=style&index=0&id=dd4bc4d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4bc4d0",
  null
  
)

export default component.exports